<div class="items-center justify-center pointer-events-none">
  <!--   Modal toggle -->
  <!--  <button
    #toggleButton
    data-modal-target="default-modal"
    data-modal-toggle="default-modal"
    class="block text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    type="button"
    style="display: none"
  >
    Toggle modal
  </button> -->

  <div id="default-modal" *ngIf="noconfirmed" tabindex="-1" aria-hidden="true"
    class="bg-opacity-70 bg-gray-400 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-4 md:p-5 space-y-4">
          <div class="flex justify-center items-center">
            <img src="assets/icons/Icon_succes.jpg" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <h1>Succès!</h1>
          </div>
          <div class="justify-center items-center">
            <p class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400">
              Votre admission a bien été prise en compte. Afin d'accéder à votre
              espace personnel, vous recevrez un autre email pour definir
              votre mot de passe.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--   <button
    #toggleButton2
    data-modal-target="already-confirmed"
    data-modal-toggle="already-confirmed"
    class="block text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
    type="button"
    style="display: none"
  >
    Toggle modal
  </button> -->

  <div *ngIf="confirmed" tabindex="-1" aria-hidden="true"
    class="bg-opacity-70 bg-gray-400 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div class="p-4 md:p-5 space-y-4 items-center justify-center">
          <div class="flex justify-center items-center">
            <img src="assets/icons/Icon-Gris.jpg" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <p class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400">
              Votre admission a bien été validée. Ce lien est obsolète. Nous
              vous invitons à réinitialiser votre mot de passe via le lien reçu
              dans votre boite mail. Si le délai de confirmation de votre
              admission est dépassé, vous serez recontacté pour les prochaines
              sessions. Merci
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Expiration modal -->
</div>
<!-- div
  *ngIf="showDialog"
  tabindex="-1"
  aria-hidden="true"
  class="bg-opacity-70 bg-gray-100 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
>
  <div class="relative w-auto my-6 mx-auto max-w-6xl">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
      
        <div class="p-4 md:p-5 space-y-4 items-center justify-center">
          <div class="flex justify-center items-center">
            <div
              class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
            >
            <div class="flex justify-center items-center">
              <img src="assets/icons/Icon-Gris.jpg" alt="" />
            </div>
            </div>
          </div>
          <div class="flex justify-center items-center">
            <p
              class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400"
            >
            Le délai de confirmation de votre candidature est dépassé. Veuillez attendre la prochaine session. 
            <br>
            Merci.
            </p>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div> -->